var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "location-components-container" },
    [
      _vm.componentFinished === true
        ? [
            _c(
              "div",
              {
                staticClass: "input-item align-items-center d-flex w-100 px-1",
              },
              [
                _c(
                  "div",
                  { staticClass: "d-none d-md-block" },
                  [
                    _vm.useIcon === true
                      ? _c("b-icon", {
                          staticClass: "mx-2",
                          attrs: {
                            icon: "geo-alt-fill",
                            variant: "brand-dark",
                            "font-scale": "1.2",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.locations.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "badge-wrapper",
                        class: _vm.useIcon === false ? "" : "",
                      },
                      _vm._l(_vm.locations, function (item, index) {
                        return _c(
                          "b-badge",
                          { key: index, staticClass: "m-1 cursor-default" },
                          [
                            _c("div", { staticClass: "badge-text ml-1" }, [
                              _vm._v(_vm._s(item.mapViewText)),
                            ]),
                            _c("b-icon", {
                              staticClass: "ml-1 clickable",
                              attrs: { icon: "x", "font-scale": "1.5" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeLocation()
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _c(
                  "b-form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.startSearch()
                      },
                    },
                  },
                  [
                    _c("b-input", {
                      staticClass: "w-100",
                      attrs: {
                        type: "text",
                        autocomplete: "off",
                        placeholder:
                          _vm.isMobile === false
                            ? _vm.t.jobSearch_V2_Location_Placeholder
                            : _vm.isMobile && _vm.locations.length < 1
                            ? _vm.t.jobSearch_V2_Location_Placeholder_Mobile
                            : "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.locationSearchMethod()
                        },
                        focus: function ($event) {
                          return _vm.openKeywordsTypeahead()
                        },
                      },
                      model: {
                        value: _vm.locationInput,
                        callback: function ($$v) {
                          _vm.locationInput = $$v
                        },
                        expression: "locationInput",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "dropdown-container d-flex justify-content-end align-items-center mr-1 mt-0",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "map-wrap clickable mr-4 d-none d-md-block",
                        on: {
                          click: function ($event) {
                            return _vm.changeMapIsActive()
                          },
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            icon: "geo-alt-fill",
                            variant: "brand-light",
                          },
                        }),
                        _c("span", { staticClass: "ml-1 text-brand-light" }, [
                          _vm._v(_vm._s(_vm.t.jobSearch_V2_Search_On_Map)),
                        ]),
                      ],
                      1
                    ),
                    _c("MinimalisticDropdown", {
                      staticClass: "p-2",
                      attrs: {
                        array: _vm.radiusDropdown,
                        selectedItem: _vm.mapInformation.Radius + " km",
                      },
                      on: {
                        itemClicked: function ($event) {
                          return _vm.radiusDropdownClicked($event)
                        },
                      },
                    }),
                    _vm.countries !== undefined && _vm.countries.length > 0
                      ? [
                          _c("MinimalisticDropdown", {
                            staticClass: "p-2 ml-2",
                            attrs: {
                              array: _vm.countries,
                              selectedItem:
                                _vm.selectedCountry.countryCode.toUpperCase(),
                            },
                            on: {
                              itemClicked: function ($event) {
                                return _vm.countrySelected($event)
                              },
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
            (_vm.locationInput.length > 1 && _vm.locationInput !== "") ||
            _vm.locationTypeaheadIsActive
              ? _c("Typeahead", {
                  attrs: {
                    typeaheadList: _vm.locationTypeahead,
                    isActive: _vm.locationTypeaheadIsActive,
                    title: _vm.t.jobSearch_V2_City,
                    sliceNumber: 5,
                    typeaheadType: 1,
                  },
                  on: {
                    closeTypeahead: function ($event) {
                      return _vm.openLocationTypeahead($event)
                    },
                    emitClickedItem: function ($event) {
                      return _vm.emitTypeaheadItem($event)
                    },
                    onEnterPressed: function ($event) {
                      return _vm.onTypeaheadSearch()
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm.isMobile === false
                        ? {
                            key: "default",
                            fn: function () {
                              return [
                                _c("RadiusSlider", {
                                  attrs: {
                                    text: _vm.t.jobSearch_V2_Area_Radius,
                                  },
                                  on: {
                                    radiusChanged: function ($event) {
                                      return _vm.radiusValueChanged($event)
                                    },
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-end align-items-center mt-2",
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "text-primary clickable",
                                        on: {
                                          click: function ($event) {
                                            _vm.locationTypeaheadIsActive = false
                                            _vm.changeShowOverlay(false)
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          staticClass: "pt-1",
                                          attrs: {
                                            icon: "x",
                                            variant: "brand-light",
                                            "font-scale": "1.5",
                                          },
                                        }),
                                        _vm._v(_vm._s(_vm.t.general_Close)),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn rounded ml-4",
                                        attrs: { variant: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onTypeaheadSearch()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.t.general_OK) +
                                            " + " +
                                            _vm._s(_vm.t.jobSearch_V2_Search)
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                })
              : _vm._e(),
            _vm.isMobile === false
              ? _c("MapView", {
                  attrs: {
                    mapInformation: _vm.mapInformation,
                    isActive: _vm.mapIsActive,
                    userInfo: _vm.userInfo,
                    countryToInit: _vm.countryToInit,
                    canSearchFromMap: _vm.canSearchFromMap,
                    settings: _vm.settings,
                  },
                  on: {
                    closeTypeahead: function ($event) {
                      return _vm.changeMapIsActive()
                    },
                    startSearchFromMap: function ($event) {
                      return _vm.startSearchFromMap()
                    },
                  },
                })
              : _vm._e(),
          ]
        : [_c("b-skeleton", { attrs: { width: "100%", height: "50px" } })],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }